export default "__VITE_ASSET__18a52ae5__"